const horizontal_rule = { group: "block" };

export default horizontal_rule;
